import type { MouseEventHandler } from 'react'
import { useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import { getRecentChatItemUrl, getRecentItemDisplayTitle, type RecentChatItem } from 'tripPlanner/pages/chat/recentChatItems'
import TripPlannerNavigationRow from './TripPlannerNavigationRow'

interface Props {
  item: RecentChatItem
  onClick: MouseEventHandler
}

function TripPlannerNavigationTripRow({ item, onClick }: Props) {
  const intl = useIntl()

  return (
    <TripPlannerNavigationRow
      to={getRecentChatItemUrl(item)}
      onClick={onClick}
      title={
        <BodyText variant="medium" weight="normal" align="start" lineClamp={1}>
          {getRecentItemDisplayTitle(intl, item.title)}
        </BodyText>
      }
    />
  )
}

export default TripPlannerNavigationTripRow
